"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var FileList_1 = require("../../../../components/FileList");
var recompose_1 = require("recompose");
var TABLE_ROW_HEIGHT = 50;
var STATIC_HEIGHT = 120;
var MIN_HEIGHT = TABLE_ROW_HEIGHT + STATIC_HEIGHT;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('SelectedFilesOrderWizard'), (0, recompose_1.withState)('height', 'setHeight', null), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var filesHeight = this.props.files.length * TABLE_ROW_HEIGHT + STATIC_HEIGHT;
        if (filesHeight <= MIN_HEIGHT) {
            this.props.setHeight(MIN_HEIGHT);
        }
        else if (filesHeight > 400) {
            this.props.setHeight(400);
        }
        else {
            this.props.setHeight(filesHeight);
        }
    },
    componentDidUpdate: function () {
        var filesHeight = this.props.files.length * TABLE_ROW_HEIGHT + STATIC_HEIGHT;
        if (filesHeight <= MIN_HEIGHT) {
            this.props.setHeight(MIN_HEIGHT);
        }
        else if (filesHeight > 400) {
            this.props.setHeight(400);
        }
        else {
            this.props.setHeight(filesHeight);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.height !== nextProps.height ||
            this.props.files.length !== nextProps.files.length) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement("div", { className: 'selected-files-list', style: { height: "".concat(props.height, "px") } },
        React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/order/step4/selected')),
        React.createElement(FileList_1.default, { selectedLanguage: props.selectedLanguage, files: props.files, selectedFiles: props.selectedFiles, metadata: props.metadata, disableFields: props.disableWizardFields, selectFile: props.selectFile, changeColor: props.changeColor, unselectFile: props.unselectFile, historyBrowsed: props.historyBrowsed, currentFrame: props.currentFrame, token: props.token, history: props.history })));
});
